import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider } from 'antd';
import { ExcelIcon } from 'icons';
import { Link, Route, Routes, useParams } from 'react-router-dom';
import DeleteModal from 'components/deleteModalView';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useBoardDocs from '../useBoardDocs';
import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { getPage } from 'hooks/useUser';
import { filter } from 'lodash';

const MainPage = () => {
  const { category } = useParams();
  const {
    data,
    columns,
    filters,
    updateInProcess,
    handleDownloadExcel,
    onChangeTableFilter,
    loading,
    onDelete,
  } = useBoardDocs(true);
  const { t } = useTranslation();
  const pages = useRecoilValue(getPage);
  const title = useMemo(() => {
    let text = t('CLASSIFICHE SETTIMANALI');
    switch (category) {
      case 'weekly':
        text = t('CLASSIFICHE SETTIMANALI');
        filters.splice(2, 1);
        break;
      case 'monthly':
        text = t('CLASSIFICHE MENSILI');
        filters.splice(2, 1);
        break;
      case 'circulars':
        text = t('CIRCOLARI');
        filters.splice(2, 1);
        break;
      case 'admin_releases':
        text = t('COMUNICATI AMMINISTRATIVI');
        filters.splice(2, 1);
        break;
      case 'manuals':
        text = t('MANUALI VILLAGE');
        filters.splice(2, 1);
        break;
      default:
        break;
    }
    return text;
  }, [category, t]);
  return (
    <>
      <PageHeader title={title}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              disabled={loading}
              onClick={handleDownloadExcel}
              icon={<ExcelIcon fill={'#fff'} />}
            >
              {t('Export')}
            </Button>
          </Col>
          {pages?.ability?.can_create && (
            <Col>
              <Link to={'new'}>
                <Button width={'138px'} big icon={<PlusOutlined />}>
                  {t('NUOVO')}
                </Button>
              </Link>
            </Col>
          )}
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <Divider />
        <Table
          columns={columns}
          dataSource={data.boarddocs}
          loading={loading}
          pagination={data.pagination}
          scroll={{ x: 1500 }}
          onChange={onChangeTableFilter}
          rowKey='id'
        // bordered
        />
      </div>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal onClickDelete={onDelete} loading={updateInProcess} />
          }
        />
      </Routes>
    </>
  );
};

export default MainPage;
